import { commonMessages } from '../../util/messages'

export const messages = {
  common: commonMessages,
  proposedTenant: {
    list: {
      error: 'There is a problem retrieving the tenants',
    },
    create: {
      error: 'There is a problem creating the tenant',
      success: 'Tenant created successfully',
    },
    retrieve: {
      error: 'There is a problem retrieving the tenant details',
    },
    update: {
      error: 'There is a problem updating the tenant',
      success: 'Tenant updated successfully',
    },
    approve: {
      error: 'There is a problem approving the selected tenants',
      success: 'Tenants approved successfully',
    },
    delete: {
      success: 'Tenant deleted successfully',
      error: 'There is a problem deleting the tenant',
    },
  },
}
